/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

"use client";

import React, { Component } from "react";
import ChaletSearchBar from "./ChaletSearchbar";

// Define props interface
interface SearchBarProps {
  toggleResultVisibility?: () => void;
  location?: string;
}

export class SearchBar extends Component<SearchBarProps> {
  state = {
    pageContentData: [],
    countryId: 0,
    ResortData: {
      ResortDisabled: true,
      countryId: -1,
    },
    startDate: new Date(),
    endDate: new Date(),
  };

  render() {
    return (
      <div className="ftco-section-search" id="ca-ftco-section-search">
        <div className="container">
          <div className="row">
            <div className="col-md-12 tabulation-search">
              <div className="element-animate">
                <div
                  className="nav nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                ></div>
              </div>
              <div className="tab-content py-5" id="tabContent">
                <div
                  className="tab-pane fade show active"
                  id="chaletSearch"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  <ChaletSearchBar
                    toggleResultVisibility={this.props.toggleResultVisibility}
                    location={this.props.location}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
